import WhoAreWe from '@/components/pages/LandingPage/WhoAreWe'
import FeaturesSection from '@/components/pages/LandingPage/FeaturesSection'
import PrioritiesSection from '@/components/pages/LandingPage/PrioritiesSection'
import MissionCarousel from '@/components/pages/LandingPage/MissionCarousel'
import EventsSection from '@/components/pages/LandingPage/EventsSection'
import MediaGallery from '@/components/sections/MediaGallery'
import MultimediaSection from '@/components/sections/MultimediaSection'
import ResourcesSection from '@/components/sections/ResourcesSection'
import { useAllWebPages } from '@/lib/api/hooks/web-pages'

import FullPageSpinner from '@/components/ui/FullPageSpinner'
import { motion } from 'framer-motion'
import { fadeUp, staggerContainer, viewportReveal } from '@/lib/motion'
import AnnouncementSection from '@/components/pages/LandingPage/AnnouncementSection'
import PressReleaseHighlights from '@/components/pages/LandingPage/PressReleaseHighlights'


const LandingPage = () => {

  const { data, isFetching, isLoading, isError, refetch } = useAllWebPages();
  const landingPageData = data?.data && data?.data.find((page) =>
    page.codeName?.toLowerCase() === 'home' ||
    page.websitePageName?.toLowerCase() === 'home'
  )?.content || null;

  if (isFetching || isLoading) {
    return <FullPageSpinner />;
  }

  if (isError) {
    return <div className="p-4 flex flex-col items-center justify-center h-full w-full gap-4">
      <p>Error loading page.</p>
      <button onClick={() => refetch()} className="px-4 py-2 bg-forestGreen-100 text-white rounded">Retry</button>
    </div>;
  }

  if (!landingPageData) {
    return <div className="p-4 flex flex-col items-center justify-center h-full w-full gap-4">
      <p>Page content not found.</p>
    </div>;
  }



  return (
    <motion.div
      className=" min-h-screen"
      variants={staggerContainer}
      initial="hidden"
      animate="visible"
    >
      <PressReleaseHighlights landingPageData={landingPageData} />

      {/* All Additional Sections */}
      <motion.div variants={fadeUp} initial="hidden" whileInView="visible" viewport={viewportReveal}>
        <WhoAreWe data={landingPageData?.HOME_WHO_ARE_WE ?? {}} />
      </motion.div>
      <motion.div variants={fadeUp} initial="hidden" whileInView="visible" viewport={viewportReveal}>
        <FeaturesSection data={landingPageData} />
      </motion.div>
      <motion.div variants={fadeUp} initial="hidden" whileInView="visible" viewport={viewportReveal}>
        <PrioritiesSection data={landingPageData} />
      </motion.div>
      <motion.div variants={fadeUp} initial="hidden" whileInView="visible" viewport={viewportReveal}>
        <MissionCarousel data={landingPageData?.HOME_WHAT_WE_DO ?? {}} />
      </motion.div>
      <motion.div variants={fadeUp} initial="hidden" whileInView="visible" viewport={viewportReveal}>
        <EventsSection data={landingPageData} />
      </motion.div>
      <motion.div variants={fadeUp} initial="hidden" whileInView="visible" viewport={viewportReveal}>
        <AnnouncementSection />
      </motion.div>
      <motion.div variants={fadeUp} initial="hidden" whileInView="visible" viewport={viewportReveal}>
        <MediaGallery data={landingPageData?.HOME_THROUGH_THE_LENS_OF_AFSA ?? {}} />
      </motion.div>
      <motion.div variants={fadeUp} initial="hidden" whileInView="visible" viewport={viewportReveal}>
        <MultimediaSection data={landingPageData} />
      </motion.div>
      <motion.div variants={fadeUp} initial="hidden" whileInView="visible" viewport={viewportReveal}>
        <ResourcesSection />
      </motion.div>

    </motion.div>
  )
}

export default LandingPage
